import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentJobApplicantNameValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		if (!control.value) {
			return null;
		}

		const value = control.value.trim().replace(/\s+/g, ' ');

		if (value.length < 2) {
			return { minLengthName: true };
		}

		if (value.length > 100) {
			return { maxLengthName: true };
		}

		const regex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;

		if (!regex.test(value)) {
			return { invalidName: true };
		}

		return null;
	};
}